import { FF_NODE_DIAGONAL_RESIZE } from '@/consts/featureFlags';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

/**
 * Single read of the diagonal-resize flag. Everything the feature touches goes through this so a
 * node's box, its content and its analytics can never disagree about whether the feature is on.
 */
export const useIsNodeDiagonalResizeEnabled = (): boolean => useFeatureFlag(FF_NODE_DIAGONAL_RESIZE).value === true;
